@if (storageSvc.currentAccount$ | async; as account) {
<button
  type="button"
  id="app-header-sidebar-btn"
  class="naked app-header__sidebar-btn ph-no-capture"
  (click)="toggleSidebarMenu()"
>
  <svg
    id="app-header-sidebar-btn-icon"
    class="app-header__sidebar-icon"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 32 32"
    stroke-width="2"
  >
    <g stroke-width="2" transform="translate(0, 0)">
      <g class="nc-interact_menu-arrow-right-o-32" transform="rotate(180 16 16)" stroke-width="2">
        <path
          data-cap="none"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          d="M4 7h24"
          stroke-dasharray="24 24"
          stroke-dashoffset="0"
          transform="translate(0 0) rotate(0 28 7)"
        />
        <path
          data-cap="none"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          d="M4 16h24"
        />
        <path
          data-cap="none"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="10"
          d="M4 25h24"
          stroke-dasharray="24 24"
          stroke-dashoffset="0"
          transform="translate(0 0) rotate(0 28 25)"
        />
      </g>
      <script stroke-width="2">
        !(function () {
          function t(e) {
            var i = e.parentNode;
            if ('svg' !== i.tagName) i = t(i);
            return i;
          }
          function e(t, e, i, n) {
            return 1 > (t /= n / 2) ? (i / 2) * t * t * t * t + e : (-i / 2) * ((t -= 2) * t * t * t - 2) + e;
          }
          function i(t) {
            ((this.element = t),
              (this.container = this.element.querySelectorAll('.nc-interact_menu-arrow-right-o-32')[0]),
              (this.topLine = this.element.getElementsByTagName('path')[0]),
              (this.bottomLine = this.element.getElementsByTagName('path')[2]),
              (this.time = { start: null, total: 300 }),
              (this.status = { interacted: !1, animating: !1 }),
              this.init());
          }
          if (!window.requestAnimationFrame) {
            var n = null;
            window.requestAnimationFrame = function (t, e) {
              var i = new Date().getTime();
              n || (n = i);
              var a = Math.max(0, 16 - (i - n)),
                r = window.setTimeout(function () {
                  t(i + a);
                }, a);
              return ((n = i + a), r);
            };
          }
          ((i.prototype.init = function () {
            var t = this;
            this.element.addEventListener('click', function () {
              t.status.animating ||
                ((t.status.animating = !0), window.requestAnimationFrame(t.triggerAnimation.bind(t)));
            });
          }),
            (i.prototype.triggerAnimation = function (t) {
              var e = this.getProgress(t),
                i = this.status.interacted ? this.time.total - e : e;
              (this.animateIcon(i), this.checkProgress(e));
            }),
            (i.prototype.getProgress = function (t) {
              return (this.time.start || (this.time.start = t), t - this.time.start);
            }),
            (i.prototype.checkProgress = function (t) {
              var e = this;
              this.time.total > t
                ? window.requestAnimationFrame(e.triggerAnimation.bind(e))
                : ((this.status = { interacted: !this.status.interacted, animating: !1 }), (this.time.start = null));
            }),
            (i.prototype.animateIcon = function (t) {
              if (t > this.time.total) t = this.time.total;
              if (0 > t) t = 0;
              var i = e(t, 0, 1, this.time.total).toFixed(2);
              (this.container.setAttribute('transform', 'rotate(' + 180 * (1 - i) + ' 16 16)'),
                this.topLine.setAttribute('transform', 'translate(0 ' + 9 * i + ') rotate(' + 45 * i + ' 28 7)'),
                this.bottomLine.setAttribute('transform', 'translate(0 ' + 9 * -i + ') rotate(' + 45 * -i + ' 28 25)'),
                this.topLine.setAttribute('stroke-dashoffset', 12 * -i),
                this.bottomLine.setAttribute('stroke-dashoffset', 12 * -i));
            }));
          var a = document.getElementsByClassName('nc-interact_menu-arrow-right-o-32');
          if (a) for (var r = 0; a.length > r; r++) new i(t(a[r]));
        })();
      </script>
    </g>
  </svg>
</button>
} @if (isExternalPageView() && (storageSvc.currentAccount$ | async) === null) {
<a routerLink="/" id="app-logo" class="logo app-header__logo"
  ><img src="/assets/images/logo.png" loading="lazy" alt="ONEOK logo" class="app-header__logo__image"
/></a>
@if( $currentRoute().includes('unsubscribe') ){
<div id="app-header-title-container" class="app-header__title-container">
  <h1 id="app-header-title" class="app-header__title">Notifications</h1>
</div>
} } @if (storageSvc.currentAccount$ | async; as account) {
<a id="app-logo" class="logo app-header__logo" [routerLink]="routeHome"
  ><img src="/assets/images/logo.png" loading="lazy" alt="ONEOK logo" class="app-header__logo__image"
/></a>
} @if (storageSvc.currentAccount$ | async; as account) {
<div id="app-header-title-container" class="app-header__title-container">
  @if (user?.HasAccountSelected) {
  <h1 id="app-header-title" class="app-header__title" [class.is-dashboard]="isDashboard">
    @if (isDashboard) {
    <span>Natural Gas</span>
    } {{ appTitleSource.value }}
  </h1>
  }
</div>
@let downloads = (downloadRequests$ | async) || []; @if( ($isDownloadVisible() || $numActiveDownloads() > 0) &&
$isNotInvoiceSummaryView() ){
<section class="downloads">
  <div class="icon-attrs">
    <svg-icon src="/assets/svg/file-arrow-down.svg" style="fill: var(--oneok-white)" />
    @if( $numActiveDownloads() > 0 ){
    <span>{{ downloads.length }}</span>
    }
  </div>
  @if( $isDownloadVisible() ){
  <div class="roll">
    <h4>Your requested PDF(s)</h4>
    <ul>
      @for( completedDownload of downloads; track completedDownload.id ){ @if( completedDownload.isInProgress === false
      && !completedDownload.userWasPresent ){
      <li class="download-item" [class.is-error]="completedDownload.errorMessage">
        <h5>{{ completedDownload.type }}</h5>
        @if( completedDownload.errorMessage ){
        <p><em>{{ completedDownload.errorMessage }}</em></p>
        }
        <dl class="attributes">
          @for( attributePair of completedDownload.attributePairs | keyvalue; track attributePair.key ){
          <div class="attribute">
            <dt>{{ attributePair.key }}</dt>
            <dd>{{ attributePair.value }}</dd>
          </div>
          }
        </dl>
      </li>
      } }
    </ul>
    <button type="button" class="naked" (click)="removeDownloads()">
      <svg-icon src="/assets/svg/x--small.svg" style="fill: var(--oneok-white)" />
    </button>
  </div>
  }
</section>
} }
